import { pipe, values, map } from 'ramda'

import type { ComplexItem, Complexes } from 'app/common/types/food/schools/complexes'
import type { ComplexLastChange } from 'app/common/types/food/schools/complexes/history'
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue'
import { sortByTitle } from 'app/common/lib/sort'

export type Item = {
  id: number
  title: string
  cost: string
  invisible: boolean
  deleted: boolean
  lastChange?: ComplexLastChange
}

const kits2SimpleItems = (complexes: Complexes, currency: string): Array<Item> =>
  pipe(
    values,
    map(
      ({
        id,
        title,
        fixed_price_enabled: fpEnabled,
        fixed_price: fp,
        visible,
        last_change: lastChange,
      }: ComplexItem): Item => ({
        id,
        title: (title || '').trim(),
        cost:
          (fpEnabled && typeof fp === 'string') || typeof fp === 'number'
            ? toFixedValueCurrency(fp, false, currency)
            : '',
        invisible: !visible,
        deleted: visible,
        lastChange,
      }),
    ),
    sortByTitle,
  )(complexes)

export default kits2SimpleItems
